import moment from 'moment'
export default {
    DateUtil: {
        formatDate: function(_date, _format){
            let _d = _date;
            if(!_d){
                _d = moment()
            }else{
                _d = moment(_d)
            }
            return _d.format(_format)
        }
    },

    TodayUtil:{
        getToday: function () {
            return moment().format('yyyy-MM-DD');
        },
        getNow: function () {
            return moment().format('yyyy-MM-DD HH:mm:ss');
        },
        getYesterday: function () {
            return moment(Date.now() - 24 * 60 * 60 * 1000).format('yyyy-MM-DD HH:mm:ss');
        },
        getWeekAgo: function () {
            return moment(Date.now() - 6*24 * 60 * 60 * 1000).format('yyyy-MM-DD');
        },
        getWeekAgo1: function () {
            return moment(Date.now() - 7*24 * 60 * 60 * 1000).format('yyyy-MM-DD');
        }
    },

    StringUtil: {
        humpToUnderline: function(str){
            return str.replace(/([A-Z])/g,"_$1").toLowerCase()
        }
    },
}
